import React from "react";
import { theme } from "../../theme";

/**
 * SummaryCard component for displaying KPI/metric boxes
 * Used consistently across dashboard components
 *
 * @param {string} title - Title/label for the metric
 * @param {string|number} value - Main value to display
 * @param {string} subtitle - Optional subtitle/description
 * @param {string} color - Border and value color (defaults to primary)
 * @param {boolean} compact - Use compact sizing (for smaller cards)
 */
const SummaryCard = ({
    title,
    value,
    subtitle = null,
    color = theme.colors.primary,
    compact = false,
    valueSize = null,
    valueFontFamily = null
}) => {
    return (
        <div
            style={{
                display: "inline-block",
                padding: compact ? "8px 12px" : "12px 18px",
                background: theme.colors.background.card,
                border: `1px solid ${color}`,
                borderRadius: theme.borderRadius.md,
                boxShadow: theme.shadows.sm,
                minWidth: compact ? 100 : 180,
                marginRight: compact ? 6 : 12,
                marginBottom: compact ? 6 : 0,
                transition: theme.transitions.normal,
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = theme.shadows.md;
                e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = theme.shadows.sm;
                e.currentTarget.style.transform = "translateY(0)";
            }}
        >
            <div
                style={{
                    color: theme.colors.text.secondary,
                    fontSize: compact ? 11 : 12,
                    fontWeight: theme.typography.fontWeight.semibold,
                    textTransform: "uppercase",
                    marginBottom: 6,
                    letterSpacing: 0.3,
                }}
            >
                {title}
            </div>
            <div
                style={{
                    color,
                    fontSize: valueSize || (compact ? 16 : 24),
                    fontWeight: theme.typography.fontWeight.bold,
                    lineHeight: 1.2,
                    fontFamily: valueFontFamily || "inherit",
                    textShadow: `0 0 10px ${color}33`
                }}
            >
                {value}
            </div>
            {subtitle && (
                <div
                    style={{
                        color: theme.colors.text.muted,
                        fontSize: compact ? 10 : 11,
                        marginTop: 4,
                    }}
                >
                    {subtitle}
                </div>
            )}
        </div>
    );
};

export default SummaryCard;
